module.exports = __webpack_public_path__ + "media/images/home/marketposters_logo-3c5a0b501ea63209bac3cd13d19e7d17.png";